import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { ExactProspectPreviewFrame } from '@/components/exact-prospect-preview-frame';
import { ErrorState, LoadingState } from '@/components/ui';
import { publicPreviewRequest } from '@/lib/public-preview-api';
import brandLogo from '../../../assets/images/brand/logo.png';

export function PublicProspectPreviewPage() {
  const { token = '' } = useParams();
  const preview = useQuery({
    queryKey: ['public-prospect-preview', token],
    queryFn: () => publicPreviewRequest(token),
    enabled: Boolean(token),
    retry: false,
  });

  if (preview.isLoading) {
    return <main className="public-preview-page"><LoadingState label="Preparing your personalized preview…" /></main>;
  }
  if (preview.error || !preview.data) {
    return <main className="public-preview-page"><ErrorState error={preview.error ?? new Error('Preview not found')} /></main>;
  }

  return (
    <main className="public-preview-page">
      <section className="public-preview-copy">
        <a className="public-preview-brand" href="https://everyvisit.app/">
          <img src={brandLogo} alt="" />
          <span>Everyvisit</span>
        </a>
        <p className="preview-eyebrow">A personalized demo for {preview.data.prospect_name}</p>
        <h1>See how your business and booking experience could look.</h1>
        <p>Swipe and tap the phone preview — it is interactive. This is a private demonstration: no account, customer, appointment, or business record will be created.</p>
      </section>
      <ExactProspectPreviewFrame content={preview.data.content} interactiveHint />
    </main>
  );
}
